/* NineTwoFive - INFO DRAWERS: words that live in Shopify pages, fetched on tap (29 Sept 2026).

   Loaded on every page (snippets/ntf-info-drawer.liquid, deferred, cached, minified by Shopify's CDN).
   Its settings arrive in window.NTF_PAGE_CFG, rendered just before it: { root, uk, product }.

   1. window.NTF_PAGE - the one way our code reads a page's text:
        NTF_PAGE.get(key)   Promise of { title, html }. key is a page handle ("returns-info") or a
                            root-relative view URL ("/nl/products/qais-…?view=sizechart").
        NTF_PAGE.peek(key)  the same, only if already cached (no request)
        NTF_PAGE.fill(el)   fills {cutoff} {date} {product} (snippets/ntf-page-body.liquid) and asks
                            ntf-cart.js to convert {threshold} (CLAUDE.md engineering rule 2)
        NTF_PAGE.url(key)   the page's own URL, with the visitor's locale/market prefix
        NTF_PAGE.still(ev)  for a drawer's wheel and touchmove: cancels a scroll that would move the
                            page behind it (see still() below)
      A page is fetched through its alternate template, templates/page.drawer.liquid, so the answer is
      a bare fragment; a response without [data-ntf-page] (a theme lacking that template renders the
      whole page instead) counts as a failed load. Cached in memory and in sessionStorage for 20
      minutes per page, locale/market root, country and currency - the {threshold} is rendered for
      the visitor's country. ?ntf-fresh in the address skips the cache, to see an admin edit at once.
      The UK market reads "<handle>-uk" where such a page exists (cfg.uk, decided in Liquid).
      Links in page text are written root-relative ("/collections/…"); they get the visitor's prefix
      here, so one page body serves /, /nl, /de, /fr and /en-gb alike.

   2. Prefetch on INTENT only - pointerdown, touchstart, mouseover or focus on a door - never on load:
        [data-ntf-drawer]                                        the product page's info rows
        the delivery line, the free-shipping row, the cart's delivery rows      -> shipping-info
        the Klarna rows                                                         -> klarna-info

   3. The drawer, on product pages (where snippets/ntf-idr-shell.liquid put its <template>): the
      delivery drawer's own shell - the .ntf-pdel-* bottom sheet on a phone and right-hand panel on
      desktop, the .ntf-fpanel-* header with its close cross, the .ntf-fdet-ok "Got it" - so there is
      one look. Plain script, no Alpine: tapita-seo-speed holds Alpine back until the first
      interaction, and these rows must open on that first tap. The shell's inline catcher holds a tap
      that lands before this file has run (window.__ntfIdrQ) and this file opens it; the rows are real
      links, so if nothing runs at all the tap simply opens the page.

   No English in here: every word comes from the page or from the shell's Liquid (rules 1 and 1b). */
(function(){
  if (window.NTF_PAGE) return;
  var CFG = window.NTF_PAGE_CFG || {};
  var ROOT = String(CFG.root || "/").replace(/\/$/, "");
  var UK = String(CFG.uk || "").split(",");
  var S = window.Shopify || {};
  /* ntfpg2 + the theme id (16 Oct): a new publish, or a change like the sets rebuild, never shows a copy saved before it */
  var PRE = "ntfpg2|" + ((S.theme && S.theme.id) || "") + "|" + ROOT + "|" + (S.country || "") + "|" + ((S.currency && S.currency.active) || "") + "|";
  var TTL = 20 * 60 * 1000;
  var FRESH = /[?&]ntf-fresh/.test(location.search);
  var mem = {}, flight = {}, failed = {};

  function url(k){ return k.charAt(0) === "/" ? k : ROOT + "/pages/" + (UK.indexOf(k) > -1 ? k + "-uk" : k); }

  function localise(el){
    if (!ROOT) return el;
    var a = el.querySelectorAll('a[href^="/"]');
    for (var i = 0; i < a.length; i++){
      var h = a[i].getAttribute("href");
      if (h.indexOf("//") === 0 || h.indexOf(ROOT + "/") === 0 || /^\/(apps|cdn)\//.test(h)) continue;
      a[i].setAttribute("href", ROOT + h);
    }
    return el;
  }

  function peek(k){
    if (mem[k] || FRESH) return mem[k] || null;
    try {
      var o = JSON.parse(sessionStorage.getItem(PRE + k) || "null");
      if (o && Date.now() - o.t < TTL) return (mem[k] = o);
    } catch (e) {}
    return null;
  }

  function get(k){
    var hit = peek(k);
    if (hit) return Promise.resolve(hit);
    if (flight[k]) return flight[k];
    flight[k] = fetch(k.charAt(0) === "/" ? k : url(k) + "?view=drawer", { credentials: "same-origin" })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        /* A <template> parses without loading anything: no image in the page starts downloading
           until the text is actually shown. */
        var t = document.createElement("template");
        t.innerHTML = html;
        var el = t.content.querySelector("[data-ntf-page]");
        if (!el) throw new Error("no drawer view");
        var o = { t: Date.now(), title: el.getAttribute("data-title") || "", html: localise(el).innerHTML.trim() };
        mem[k] = o;
        delete flight[k];
        try { sessionStorage.setItem(PRE + k, JSON.stringify(o)); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent("ntf:page", { detail: { key: k } })); } catch (e) {}
        return o;
      })
      .catch(function(err){ delete flight[k]; failed[k] = Date.now(); throw err; });
    return flight[k];
  }

  function fill(root){
    root = root || document;
    var st = window.NTF_SHIP_STATE || {};
    var v = { cutoff: st.cutoff || "", date: (st.lead && st.lead.date) || "", product: CFG.product || "" };
    var els = root.querySelectorAll("[data-ntf-fill]");
    for (var i = 0; i < els.length; i++){
      var s = v[els[i].getAttribute("data-ntf-fill")] || "";
      if (els[i].textContent !== s) els[i].textContent = s;
    }
    if (typeof window.NTF_PAINT_FF === "function" && root.querySelector("[data-ntf-ff]")) {
      try { window.NTF_PAINT_FF(); } catch (e) {}
    }
  }

  var DOORS = [
    ["[data-ntf-drawer]", ""],
    ["[data-ntf-open-delivery],.ntf-pdel-line,.ntf-deliv-btn,.ntf-ship-row,.ntf-fdet--deliv .ntf-fdet-sum", "shipping-info"],
    [".ntf-klarna-tap,.ntf-klarna-learn", "klarna-info"]
  ];
  function intent(e){
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < DOORS.length; i++){
      var d = t.closest(DOORS[i][0]);
      if (!d) continue;
      var k = DOORS[i][1] || d.getAttribute("data-ntf-drawer");
      if (k && !peek(k) && !(failed[k] > Date.now() - 30000)) get(k).catch(function(){});
      return;
    }
  }
  ["pointerdown", "touchstart", "mouseover", "focusin"].forEach(function(n){
    document.addEventListener(n, intent, { capture: true, passive: true });
  });
  /* The delivery date and the cut-off arrive after load and move with a country pick. */
  window.addEventListener("ntf:ship-state", function(){
    if (document.querySelector("[data-ntf-fill]")) fill(document);
  });

  /* The page behind a drawer stays where it is, and nothing on it moves (Kai, 2 Oct: "the screen
     moves up and when I click back outside the drawer the screen moves down again"). The info
     drawers first locked the page with overflow:hidden on html and body. With both set, the body
     becomes a scroll container of its own, and position:sticky then sticks to the body, which never
     scrolls: the header left the screen and the product column jumped up by hundreds of pixels, and
     back on close. So no layout lock at all - the head guards' rule for the cart drawer ("the page
     behind the drawer stops scrolling, WITHOUT moving"). A wheel or a swipe that starts on a drawer
     and has nothing of its own to scroll is cancelled here; one inside a scroller with room is left
     to it, and overscroll-behavior:contain on .ntf-pdel-body keeps it from running on into the page.
     The listener sits on the drawer (its scrim, which wraps or neighbours its panel), never on the
     document, so scrolling anywhere else is not slowed.
       the info drawers    hold(box), in build() below
       the delivery drawer @wheel and @touchmove on its scrim (snippets/ntf-product-delivery.liquid):
                           Alpine teleports that scrim to <body> when it starts, so there is nothing
                           here to attach to at load. Its own lock is the theme's popup store, which
                           has not stopped the page since scrolling went back to the document (head
                           guards): measured 2 Oct, a wheel turn or a swipe on its dimmed page
                           scrolled the page behind it. */
  function still(e){
    if (e.cancelable === false) return;                             /* a scroll already under way */
    if (e.ctrlKey || (e.touches && e.touches.length > 1)) return;   /* zoom, not scroll */
    for (var el = e.target; el && el.nodeType === 1 && el !== e.currentTarget; el = el.parentElement){
      var cs = getComputedStyle(el);
      if (/auto|scroll/.test(cs.overflowY) && el.scrollHeight - el.clientHeight > 1) return;
      if (/auto|scroll/.test(cs.overflowX) && el.scrollWidth - el.clientWidth > 1) return;
    }
    e.preventDefault();
  }
  function hold(el){
    el.addEventListener("wheel", still, { passive: false });
    el.addEventListener("touchmove", still, { passive: false });
  }

  window.NTF_PAGE = { get: get, peek: peek, fill: fill, url: url, still: still };

  /* The Klarna popup's words (snippets/klarna-installments-global.liquid calls this when it opens):
     the page "klarna-info" gives the headline and the text, and the plan cards - this cart's amounts,
     which stay in the popup's own markup - move into the page's {plans} slot. Once per page view: a
     second render would have to move the plans back out first. If the page cannot be read, the plans
     stay and the page itself is offered. */
  var klarnaDone = false;
  window.NTF_KLARNA_TEXT = function(modal){
    if (klarnaDone || !modal) return;
    var pg = modal.querySelector("[data-ntf-k-pg]"), plans = modal.querySelector("[data-ntf-k-plans]");
    var err = modal.querySelector("[data-ntf-k-err]"), title = modal.querySelector("[data-ntf-k-title]");
    if (!pg || !title) return;
    function put(o){
      if (klarnaDone) return;
      klarnaDone = true;
      title.textContent = o.title;
      pg.innerHTML = o.html;
      var slot = pg.querySelector('[data-ntf-slot="plans"]');
      if (slot && plans) slot.appendChild(plans);
      fill(pg);
    }
    function failed(){
      if (klarnaDone) return;
      var w = pg.querySelector("[data-ntf-k-wait]");
      if (w) w.hidden = true;
      if (err) err.hidden = false;
    }
    var hit = peek("klarna-info");
    if (hit) put(hit); else get("klarna-info").then(put, failed);
  };
  try { window.dispatchEvent(new CustomEvent("ntf:page-ready")); } catch (e) {}

  /* An info page opened on its own (templates/page.info.liquid): the same links and values. */
  var own = document.querySelectorAll(".ntf-pg");
  for (var j = 0; j < own.length; j++) localise(own[j]);
  if (document.querySelector("[data-ntf-fill]")) fill(document);

  /* ---- The drawer (product pages) ------------------------------------------------------------ */
  var tpl = document.getElementById("ntf-idr-tpl");
  if (!tpl || !tpl.content) return;
  var box, panel, ttl, body, wait, err, link, back = null, seq = 0, shut = 0;

  function q(s){ return box.querySelector(s); }
  function build(){
    box = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(box);
    panel = q('[role="dialog"]'); ttl = q("#ntf-idr-t"); body = q(".ntf-idr-body");
    wait = q("[data-ntf-idr-wait]"); err = q("[data-ntf-idr-err]"); link = q("[data-ntf-idr-link]");
    hold(box);
    box.addEventListener("click", function(e){
      var t = e.target, b;
      if (t.closest("[data-ntf-idr-x]")) { close(); return; }
      /* A link that opens the chat (the bangle chart's custom offer, 10 Oct): the drawer closes and
         Zipchat opens with the first words already typed. Those words come from the link's
         data-ntf-chat attribute, rendered in Liquid, so they are translated; Zipchat.open() without a
         message does nothing (measured). Without Zipchat the link is simply followed (contact page). */
      if ((b = t.closest("[data-ntf-chat]")) && window.Zipchat && typeof window.Zipchat.open === "function") {
        e.preventDefault(); close();
        var msg = b.getAttribute("data-ntf-chat") || " ";
        setTimeout(function(){ var ok = false; try { ok = window.Zipchat.open({ prefillMessage: msg }); } catch (x) {} if (ok === false) location.href = b.href; }, 350);
        return;
      }
      /* The size chart's tabs and its metric/inch switch (templates/product.sizechart.liquid).
         Attributes only, so any drawer content can use them. */
      /* The size views' head tabs (snippets/ntf-size-tabs.liquid, Kai's variant A, 17 Oct 2026): a tab shows its pane
         of the same view; nothing is fetched, the page behind does not move, the drawer's text starts at its top. */
      if ((b = t.closest("button[data-szh]"))) {
        var v = b.getAttribute("data-szh");
        panel.querySelectorAll("button[data-szh]").forEach(function(x){ x.setAttribute("aria-selected", String(x === b)); });
        body.querySelectorAll("[data-szh-pane]").forEach(function(p){ p.hidden = p.getAttribute("data-szh-pane") !== v; });
        var sc = q(".ntf-pdel-body"); if (sc) sc.scrollTop = 0;
        return;
      }
      if ((b = t.closest("[data-tab-btn]"))) {
        var root = b.closest("[data-tabs]") || body, i = b.getAttribute("data-tab-btn");
        root.querySelectorAll("[data-tab-btn]").forEach(function(x){ x.setAttribute("aria-selected", String(x === b)); });
        root.querySelectorAll("[data-tab-panel]").forEach(function(p){ p.hidden = p.getAttribute("data-tab-panel") !== i; });
      } else if ((b = t.closest("[data-unit]"))) {
        var w = b.closest("[data-units]");
        if (!w) return;
        w.setAttribute("data-units", b.getAttribute("data-unit"));
        w.querySelectorAll("[data-unit]").forEach(function(x){ x.setAttribute("aria-pressed", String(x === b)); });
      }
    });
  }
  /* A view may bring its own head row ([data-ntf-head], the size views' tabs): it is lifted into the drawer's head, beside
     the close cross, for as long as that view shows; the title stays there for screen readers only (its CSS is the view's). */
  function head(){
    var hd = ttl.parentNode, old = hd.querySelector("[data-ntf-head]"), nw = body.querySelector("[data-ntf-head]");
    if (old) hd.removeChild(old);
    if (nw) hd.insertBefore(nw, ttl);
  }
  function show(o){
    ttl.textContent = o.title;
    body.innerHTML = o.html;
    head();
    wait.hidden = true; err.hidden = true;
    fill(body);
  }
  function open(k, a){
    if (!k) return false;
    if (!box) build();
    clearTimeout(shut);
    var my = ++seq;
    back = a || null;
    link.href = (a && a.getAttribute("href")) || url(k);
    ttl.textContent = ""; body.innerHTML = ""; head(); wait.hidden = false; err.hidden = true;
    box.hidden = false;
    document.documentElement.classList.add("ntf-idr-open");
    /* Two frames, so the panel is painted off-screen first and the slide actually runs - the
       delivery drawer's x-transition, done by hand. */
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      panel.classList.remove("ntf-pdel-off"); panel.classList.add("ntf-pdel-on");
    }); });
    try { panel.focus({ preventScroll: true }); } catch (e) {}
    var hit = peek(k);
    if (hit) show(hit);
    else get(k).then(function(o){ if (my === seq) show(o); },
                     function(){ if (my === seq) { wait.hidden = true; err.hidden = false; } });
    return true;
  }
  function close(){
    if (!box || box.hidden) return;
    seq++;
    panel.classList.remove("ntf-pdel-on"); panel.classList.add("ntf-pdel-off");
    document.documentElement.classList.remove("ntf-idr-open");
    shut = setTimeout(function(){ box.hidden = true; body.innerHTML = ""; head(); }, 300);
    if (back) { try { back.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openRow(a){ return open(a.getAttribute("data-ntf-drawer"), a); }

  /* Capture phase, so the drawer wins over any other handler on the link. A modified click (new tab,
     new window) is left to the browser: it opens the page, which is what was asked for. */
  document.addEventListener("click", function(e){
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest("a[data-ntf-drawer]");
    if (a && openRow(a)) e.preventDefault();
  }, true);
  /* The keys that scroll a page scroll the drawer's text instead: the same rule as still() above,
     for the keyboard. A step in pixels, or a share of the visible height. */
  var KEYS = { ArrowDown: 40, ArrowUp: -40, PageDown: 0.9, PageUp: -0.9, " ": 0.9, Home: -1e6, End: 1e6 };
  document.addEventListener("keydown", function(e){
    if (!box || box.hidden) return;
    if (e.key === "Escape") { close(); return; }
    if (KEYS.hasOwnProperty(e.key) && !e.ctrlKey && !e.metaKey && !e.altKey) {
      var tag = (e.target && e.target.tagName) || "";
      if (/^(INPUT|SELECT|TEXTAREA)$/.test(tag)) return;
      if (e.key === " " && /^(A|BUTTON|VIDEO)$/.test(tag)) return;   /* Space presses a button */
      e.preventDefault();
      var sc = q(".ntf-pdel-body"), d = KEYS[e.key] * (e.key === " " && e.shiftKey ? -1 : 1);
      if (sc) sc.scrollTop += Math.abs(d) < 1 ? d * sc.clientHeight : d;
      return;
    }
    if (e.key !== "Tab") return;
    var f = [].filter.call(panel.querySelectorAll("a[href],button,video[controls]"), function(x){ return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === panel)) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* Hand-over from the shell's inline catcher: from now on this file takes the taps, and a tap it
     held while this file was loading is opened now. */
  window.__ntfIdrOpen = openRow;
  var held = window.__ntfIdrQ;
  window.__ntfIdrQ = null;
  if (held) openRow(held);
})();
